import request from '@/utils/request'

let FengtanApi = {
  /*文章列表*/
  fenglist(data) {
    // return request._post('/shop/plus.feng.feng/index1', data);
    return request._post('/shop/plus.feng.feng/index', data);
  },
  /*封坛详情*/
  fengDetail(data) {
    return request._post('/shop/plus.feng.feng/detail', data);
  },
  /*回寄封坛条详情*/
  ArticleFengTan(data) {
    return request._post('/shop/plus.feng.feng/fengArticle', data);
  },
  /*确认封坛*/
  FengTan(data) {
    return request._post('/shop/plus.feng.feng/fengTan', data);
  },





}
export default FengtanApi;



// WEBPACK FOOTER //
// ./src/api/fengtan.js